"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.personSchema = exports.personSchemaReference = exports.personIdSchema = void 0;
const zod_1 = require("zod");
const images_schema_1 = require("./images.schema");
const organizationSchema = __importStar(require("./organization.schema"));
exports.personIdSchema = zod_1.z.string().uuid().describe("Unique identifier of a person in the format of UUID");
exports.personSchemaReference = zod_1.z
    .object({
    id: exports.personIdSchema,
    type: zod_1.z.literal("person"),
})
    .strict();
const personBaseSchema = zod_1.z
    .object({
    id: exports.personIdSchema,
    additionalName: zod_1.z.string().describe("Additional name (middle name)").optional(),
    honorificPrefix: zod_1.z.string().describe("Honorifics preceding a person's name").optional(),
    honorificSuffix: zod_1.z.string().describe("Honorifics following a person's name").optional(),
    sortName: zod_1.z.string().describe("A name to use in a lexicographically ordered list").optional(),
    alternateNames: zod_1.z.array(zod_1.z.string()).describe("Alternate names to use for example in search").optional(),
    images: images_schema_1.imagesSchema.optional(),
    memberOf: zod_1.z
        .lazy(() => zod_1.z
        .array(zod_1.z.object({ id: organizationSchema.organizationIdSchema }).describe("Reference to an organization").strict())
        .min(1)
        .describe("List of organizations a person is a member of"))
        .optional(),
})
    .strict();
const personWithFullName = zod_1.z.object({
    name: zod_1.z.string().describe("Person's preferred full name"),
    familyName: zod_1.z.string().describe("Family name (last name)").optional(),
    givenName: zod_1.z.string().describe("Given name (first name)").optional(),
});
const personWithFamilyAndGivenName = zod_1.z.object({
    name: zod_1.z.string().describe("Person's preferred full name").optional(),
    familyName: zod_1.z.string().describe("Family name (last name)"),
    givenName: zod_1.z.string().describe("Given name (first name)"),
});
exports.personSchema = zod_1.z.union([personBaseSchema.extend(personWithFullName.shape), personBaseSchema.extend(personWithFamilyAndGivenName.shape)]).describe("A human being");
